import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';

const SwitchStyled = styled.label`
    position: relative;
    display: inline-block;
    width: 48px;
    height: 28px;

    input {
        display:none;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }
      
    .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    
    input:checked + .slider {
        background-color: ${Colours.primary};
    }
    
    input:focus + .slider {
        box-shadow: 0 0 1px ${Colours.primary};
    }
    
    input:checked + .slider:before {
        -webkit-transform: translateX(20px);
        -ms-transform: translateX(20px);
        transform: translateX(20px);
    }
    
    /* Rounded sliders */
    .slider.round {
        border-radius: 28px;
    }
    
    .slider.round:before {
        border-radius: 50%;
    }
`;

export default ({ className, checked, onChange }: any) => (
    <SwitchStyled className={className}>
        <input type="checkbox" checked={checked} onChange={onChange}/>
        <span className="slider round" />
    </SwitchStyled>
)


// WEBPACK FOOTER //
// ./src/Components/Switch.tsx